import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

import { ANALYTICS_DEBUG_KEY, logger } from '../utils/logger';

export const useAnalyticsDebug = () => {
  const [value, setValue, remove] = useLocalStorage(ANALYTICS_DEBUG_KEY, false);

  const onClear = useCallback(() => {
    logger('Clearing analytics debug');

    remove();
  }, [remove]);

  const onToggle = useCallback(() => {
    if (!value) {
      logger(`Enabling analytics debugger`);
      setValue(true);
    } else {
      logger(`Disabling analytics debugger`);
      remove();
    }
  }, [setValue, value, remove]);

  return { onClear, onToggle, value };
};
